/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_Control_LabelInputs */

const vi_grower_area_camera_check_control_label = /** @type {(inputs: Grower_Area_Camera_Check_Control_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều khiển`)
};

/**

* @param {Grower_Area_Camera_Check_Control_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_control_label = /** @type {((inputs?: Grower_Area_Camera_Check_Control_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_Control_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_control_label(inputs)
});